<template>
	<div id="contact">
		<NavMenu :activeIndex="curIndex"></NavMenu>
		<div class="liuBai"></div>
		<div class="bannerImgCon"><el-image class="bannerImg" :src="baseImgUrl + contactVo.banner" fit="cover"></el-image></div>
		<div class="main">
			<el-tabs v-model="activeName" class="tabCon">
				<el-tab-pane label="Contact Information" name="contactUs">
					<div class="contactUs">
						<div class="mapImgCon" @click="mapDialog_sm_and_up = true"></div>
						<div class="info">
							<div class="infoItem">Address：{{contactVo.addressEn}}</div>
							<div class="infoItem">Tel：{{contactVo.tel}}</div>
							<div class="infoItem">Email：{{contactVo.mail}}</div>
							<div class="infoItem">Website：{{contactVo.web}}</div>
							<el-image class="qrImg" :src="baseImgUrl + contactVo.officialQr"></el-image>
							<el-image class="qrImg" :src="baseImgUrl + contactVo.webQr"></el-image>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="Online Message" name="suggest">
					<div class="suggest">
						<el-input class="suggestItem" placeholder="Name" v-model="message.name" clearable></el-input>
						<el-input class="suggestItem" placeholder="Email" v-model="message.mail" clearable></el-input>
						<el-input class="suggestItem" placeholder="Tel" v-model="message.tel" clearable></el-input>
						<el-input  class="suggestItem" type="textarea" :rows="6" placeholder="Message Contents *" v-model="message.content"></el-input>
						<el-button class="suggestItem sBtn" @click="beforeSubmit">Submit Message</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
			<el-dialog :visible.sync="mapDialog_sm_and_up" customClass="dialogWidth">
				<baidu-map class="map" :center="center" :zoom="zoom" @ready="handler" :scroll-wheel-zoom="true">
					<bm-marker :position="center"></bm-marker>
				</baidu-map>
			</el-dialog>

			<!--提交留言-->
			<el-dialog title="是否确认提交留言" :visible.sync="messageDialogVisible" customClass="messageDialogWidth">
				<div class="verifyCon">
					<div class="verifyLeft"><div class="verifyImgCon"><el-image class="verifyImg" :src="verifyImg" @click="refreshVerifyImg"></el-image></div></div>
					<div class="verifyRight"><el-input class="in verifyImgIn" v-model="message.verify" placeholder="Please enter the verification code"></el-input></div>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="messageDialogVisible=false">cancel</el-button>
					<el-button type="primary" @click="messageSubmit">submit</el-button>
				</span>
			</el-dialog>
		</div>
		<Bottom></Bottom>
	</div>
</template>

<script>
import NavMenu from '../../../copms/NavMenu'
import Bottom from '../../../copms/Bottom'
export default {
	name: "Contact",
	components: { NavMenu,Bottom },
	data() {
		return {
			curIndex: '7',
			baseImgUrl: process.env.VUE_APP_IMGURL,
			contactVo: { address:'', tel:'', mail:'', web:'', banner:'', official:'' },
			activeName: 'contactUs',
			mapDialog_xs: false,
			mapDialog_sm_and_up: false,
			center: { lng: 0, lat: 0 }, //经纬度
			zoom: 3, //地图展示级别
			message: { name: '', mail:'', tel: '', content: '', verify: '' },
			messageDialogVisible: false,
			verifyImg: ''
		}
	},
	watch: {
		'message.name': {
			handler(newName) { this.message.name = newName.replace(/[^a-zA-Z\u4E00-\u9FA5]/g,'')},
			immediate: true,
			deep: true
		},
		'message.mail': {
			handler(newName) { this.message.mail = newName.replace(/[^a-zA-Z0-9@\u4E00-\u9FA5]/g,'')},
			immediate: true,
			deep: true
		},
		'message.tel': {
			handler(newName) { this.message.tel = newName.replace(/[^0-9-]/g,'')},
			immediate: true,
			deep: true
		},
		'message.content': {
			handler(newName) { this.message.content = newName.replace(/[^a-zA-Z0-9@\u4E00-\u9FA5]/g,'')},
			immediate: true,
			deep: true
		},
		'message.verify': {
			handler(newName) { this.message.verify = newName.replace(/[^0-9]/g,'')},
			immediate: true,
			deep: true
		},
	},
	mounted() {
		this.$api.get('contact/get').then(res => {
			this.contactVo = res;
		});
	},
	methods: {
		handler() {
			this.center.lng = 117.713697
			this.center.lat = 39.107227
			this.zoom = 14;
		},
		getVerifyImg(){ //获取后台验证码
			this.$api.getByParams('message/getVerifyImg', { responseType:'blob' }).then(res => { //指定接收类型为blob
				this.verifyImg = window.URL.createObjectURL(res); //blob转换
			}).catch((err) => {});
		},
		refreshVerifyImg(){ //刷新验证码
			this.getVerifyImg();
		},
		beforeSubmit(){
			if(''===this.message.content || this.message.content===null){
				this.$message({message: 'The message cannot be empty', type: 'warning', duration: 2000});
				return false;
			}
			this.getVerifyImg();
			this.messageDialogVisible = true;
		},
		messageSubmit(){
			if(''===this.message.verify || this.message.verify===null){
				this.$message({message: 'The verification code cannot be empty', type: 'warning', duration: 2000});
				return false;
			}
			this.$api.post('message/submitMessage', this.message).then(res => {
				if(res){
					this.$message({message: 'Message success', type: 'success', duration: 2000});
					this.message = { name: '', mail:'', tel: '', content: '', verify: '' };
					setTimeout(() => {
						this.messageDialogVisible = false;
					}, 1200);
				}else {
					this.$message({message: 'The message is abnormal, Please contact the administrator', type: 'error', duration: 2000});
				}
			}).catch((err) => {});
		}
	}
}
</script>

<style>
	html{ width: 100%; height: 100%; }
	body { margin: 0; padding: 0; width: 100%; height: 100%; }
	::-webkit-scrollbar { width: 5px; height: 6px; }
	::-webkit-scrollbar-track { background-color: #ffffff; border-radius: 2px; }
	::-webkit-scrollbar-thumb { background-color: #73869c; border-radius: 2px; border: 1px solid #6d6d6d; }
	* { scrollbar-color: light; scrollbar-width: thin; } /*火狐*/
</style>
<style scoped>
.main{ font-family: 'SiYuan-Light', sans-serif; }
.verifyCon{ display: flex; align-items: center; }
.verifyLeft{ width: 45%; height: 43px; background: #e6f0f3; border-top-left-radius: 4px; border-bottom-left-radius: 4px; }
.verifyImgCon{ width: 96%; height: 100%; margin: 0 auto; }
.verifyImg{ height: 100%; width: 100%; object-fit: fill; cursor: pointer; overflow: hidden; }
::v-deep .verifyImgIn .el-input__inner{ border-top-left-radius: 0; border-bottom-left-radius: 0; }
.verifyRight{ width: 55%; height: 100%; }
	@media (max-width: 726px){
		.liuBai{ height: 88px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 90%; height: fit-content; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 2px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 50px; line-height: 50px; }
		::v-deep .el-tabs__item{ font-size: 16px; }
		.contactUs{ height: 100%; width: 100%; padding: 10px 0 10px 10px; }
		.mapImgCon{ width: 92%; height: 340px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: fit-content; padding: 10px 0 0 4px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 15px; margin-bottom: 10px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 200px; height: 200px; margin-top: 16px; margin-right: 36px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 16px 0 0 0; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 16px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 97% !important; height: 480px; }
		::v-deep .dialogWidth{ width: 97%; }
		::v-deep .messageDialogWidth{ width: 90%; }
	}
	@media (min-width: 726px) and (max-width: 999px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 90%; height: 505px; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 14px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 60px; line-height: 60px; padding-left: 15px; }
		::v-deep .el-tabs__item{ font-size: 18px; }
		.contactUs{ display: flex; flex-wrap: nowrap; height: 100%; width: 100%; padding: 20px 10px 20px 10px; }
		.mapImgCon{ width: 700px; height: 380px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: 380px; padding: 0 0 0 12px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 15px; margin-bottom: 10px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 100px; height: 100px; margin-top: 140px; margin-right: 5px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 18px 0 0 15px; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 18px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 100%; height: 620px; }
		::v-deep .dialogWidth{ width: 88%; }
		::v-deep .messageDialogWidth{ width: 70%; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 90%; height: 605px; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 14px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 60px; line-height: 60px; padding-left: 15px; }
		::v-deep .el-tabs__item{ font-size: 18px; }
		.contactUs{ display: flex; flex-wrap: nowrap; height: 100%; width: 100%; padding: 20px 10px 20px 10px; }
		.mapImgCon{ width: 1000px; height: 480px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: 480px; padding: 0 0 0 20px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 17px; margin-bottom: 22px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 116px; height: 116px; margin-top: 154px; margin-right: 10px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 26px 0 0 15px; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 33px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 100%; height: 620px; }
		::v-deep .dialogWidth{ width: 80%; }
		::v-deep .messageDialogWidth{ width: 50%; }
	}
	@media (min-width: 1252px) and (max-width: 1845px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 80%; height: 605px; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 14px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 60px; line-height: 60px; padding-left: 15px; }
		::v-deep .el-tabs__item{ font-size: 18px; }
		.contactUs{ display: flex; flex-wrap: nowrap; height: 100%; width: 100%; padding: 20px 10px 20px 10px; }
		.mapImgCon{ width: 1000px; height: 480px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: 480px; padding: 0 0 0 38px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 17px; margin-bottom: 22px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 120px; height: 120px; margin-top: 150px; margin-right: 10px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 26px 0 0 15px; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 33px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 100%; height: 660px; }
		::v-deep .dialogWidth{ width: 70%; }
		::v-deep .messageDialogWidth{ width: 40%; }
	}
	@media (min-width: 1846px) and (max-width: 2200px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 80%; height: 605px; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 14px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 60px; line-height: 60px; padding-left: 15px; }
		::v-deep .el-tabs__item{ font-size: 18px; }
		.contactUs{ display: flex; flex-wrap: nowrap; height: 100%; width: 100%; padding: 20px 10px 20px 10px; }
		.mapImgCon{ width: 1000px; height: 480px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: 480px; padding: 0 0 0 58px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 17px; margin-bottom: 26px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 190px; height: 190px; margin-top: 65px; margin-right: 20px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 26px 0 0 15px; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 33px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 100%; height: 660px; }
		::v-deep .dialogWidth{ width: 66%; }
		::v-deep .messageDialogWidth{ width: 30%; }
	}
	@media (min-width: 2201px){
		.liuBai{ height: 98px; }
		.bannerImgCon{ height: 120px; }
		.bannerImg{ width: 100%; height: 120px; }
		.main{ padding: 0; width: 80%; height: 605px; margin: 0 auto; overflow: hidden; }
		.tabCon{ margin-top: 14px; height: 100%; width: 100%;  }
		::v-deep .el-tabs__header{ margin: 0 0 2px 0; height: 60px; line-height: 60px; padding-left: 15px; }
		::v-deep .el-tabs__item{ font-size: 18px; }
		.contactUs{ display: flex; flex-wrap: nowrap; height: 100%; width: 100%; padding: 20px 10px 20px 10px; }
		.mapImgCon{ width: 1200px; height: 480px; transition: all 0.3s linear; animation: fadeInLeft; animation-duration: 1.8s;}
		.info{ width: fit-content; height: 480px; padding: 0 0 0 70px; animation: fadeInRight; animation-duration: 1.6s; }
		.infoItem{ font-size: 17px; margin-bottom: 26px; letter-spacing: 2px; animation: fadeInDown; animation-duration: 1.8s; }
		.qrImg{ width: 222px; height: 222px; margin-top: 35px; margin-right: 30px; animation: fadeIn; animation-duration: 1.8s; }
		.suggest{ padding: 26px 0 0 15px; animation: fadeInDown; animation-duration: 1s; }
		.suggestItem{ margin-bottom: 33px; }
		.mapImgCon{ background: url("http://ds-global.cn/imgs/assets/contact/map.jpg") center no-repeat; border: 5px solid #ffffff; }
		.mapImgCon:hover{ background: url("http://ds-global.cn/imgs/assets/contact/map_hover.jpg") center no-repeat; cursor: pointer; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2); }
		.map{ width: 100%; height: 660px; }
		::v-deep .dialogWidth{ width: 62%; }
		::v-deep .messageDialogWidth{ width: 24%; }
	}
</style>